module.exports = __webpack_public_path__ + "static/img/当心电离辐射.eb7f391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/当心电离辐射.png
// module id = c2z6
// module chunks = 1